import {IntermediatePart} from "../../intermediatePart";
import {Shower} from "../../parts/shower";
import {IS_BATHROOM_OLD_BV_SCENE} from "../../../../../config";

export default class BackgroundBG extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'background_bg';
    this.partName = 'Background BG';
    this.windowNeededLayouts = [1];
  }

  getArrayOfConditions() {
    const layout = this.getParent().layout;
    let conditions = super.getArrayOfConditions(); //roomLayout
    // const windowParent = layout.parts[WindowParent.id];
    const showerParent = layout.parts[Shower.id];

    // const windowBody = windowParent.windowBody;
    // if (windowBody && this.windowNeededLayouts.includes(layout.type)) {
    //   conditions.push({
    //     propName: "Window",
    //     propValue: (windowBody && windowBody.activeFeature && windowBody.disabled) ? "Off" : "On"
    //   })
    // }

    if (showerParent && showerParent.showerSize() && !IS_BATHROOM_OLD_BV_SCENE) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerParent.showerSize()
      })
    }

    return conditions
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Background.BackgroundBG;
    }
  }
}
